import { Route, Routes } from "react-router-dom";
import React from "react";
import PropertiesDashboard from "js/pages/Properties/PropertiesDashboard";
import PropertyLandlordForm from "js/components/Properties/PropertyWithLandlordModal/PropertyLandlordForm";
import NotFound from "js/pages/NotFound";
import PropertyDetails from "js/components/Properties/PropertyDetails/PropertyDetails";

const Property = () => {
  return (
    <Routes>
      <Route path="create" element={<PropertyLandlordForm />} />
      <Route path=":propertyId/details" element={<PropertyDetails />} />
      <Route path="" element={<PropertiesDashboard />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default Property;
